@file:UseSerializers(BigDecimalSerializer::class)
@file:Suppress("unused")

package net.sergeych.ugdx.shared.api

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import net.sergeych.kiloparsec.command
import net.sergeych.ugdx.shared.BigDecimalSerializer
import net.sergeych.ugdx.shared.trader.*

@Serializable
data class TraderGetBookArgs(val currencyPair: CurrencyPair, val lastKnownAt: Instant?)

val cmdTraderGetBook by command<TraderGetBookArgs, OrderbookSnapshot>()

@Serializable
data class CurrencyPairsResult(val currencyPairs: List<CurrencyPair>)

val cmdTraderListCurrencyPairs by command<Unit, CurrencyPairsResult>()

@Serializable
data class TradeOrderCreationArgs(
    val currencyPair: CurrencyPair,
    val isBuy: Boolean,
    val amount: BigDecimal,
    val limit: BigDecimal?,
    val stop: String?,
    val allOrNothing: Boolean,
    val buyAccountId: Long,
    val sellAccountId: Long,
    val expiresAt: Instant,
)

val cmdTraderCreateOrder by command<TradeOrderCreationArgs, TradeOrder>()

@Serializable
data class TraderOrderIdArgs(val traderOrderId: Long)

val cmdTraderGetOrder by command<TraderOrderIdArgs, TradeOrder>()
val cmdTraderUpdateOrder by command<TradeOrder, TradeOrder>()
val cmdTraderDeleteOrder by command<TraderOrderIdArgs, TradeOrder>()

@Serializable
data class TradeListOrderArgs(
    val currencyPair: CurrencyPair,
    val beforeId: Long? = null,
    val limit: Int = 50,
    val onlyActive: Boolean = false,
)

/**
 * Result of querying for (own) trade orders. Note that orders are always sorted by id bigger (e.g. most recent) first,
 * and are being paged from newest to oldest. To get the more orders not included in the list, qeury [Trader.getOrders]
 * with 'afterId` set to __smallest received `id`__, what means, the last. Note also that if received list contains
 * less elements that was requested it does not necessarily mean that there are no more trade orders, always check
 * the [hasMore] parameter.
 *
 */
@Serializable
data class TradeOrders(val tradeOrders: List<TradeOrder>, val hasMore: Boolean)

val cmdTraderMyOrders by command<TradeListOrderArgs, TradeOrders>()

@Serializable
data class TradeOrderLogArgs(
    val tradeOrderId: Long,
    val afterId: Long = 0,
    val limit: Int = 100,
)

val cmdTradeOrderLog by command<TradeOrderLogArgs,TradeOrder.LogResult>()

@Serializable
data class TraderStatsArgs(val currencyPair: CurrencyPair,val from: Instant,val rate: StatSampleRate,val size: Int)

@Serializable
data class TraderStatsResult(val sticks: List<Pair<Instant,CandleStick>>)

val cmdTraderGetStats by command<TraderStatsArgs,TraderStatsResult>()

val cmdTraderGetDepthOfMarket by command<CurrencyPair, DepthOfMarket>()